import axios from 'axios';
import { auth } from './models';

//local address for AVD 10.0.2.2

const api = axios.create({
  baseURL: window.location.hostname === "localhost" 
    ? "http://localhost:82/api" // On pointe enfin vers ton ordi !
    : window.location.protocol + "//" + window.location.host + "/api",
});

// On remplace l'intercepteur vide par celui-ci :
api.interceptors.request.use(
  request => {
    const token = auth.getToken(); // On récupère la clé
    if (token) {
      request.headers['Authorization'] = `Bearer ${token}`; // On l'injecte automatiquement
    }
    return request;
  },
  error => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  },
);

const ApiService = {
  async setToken(value) {
    api.defaults.headers.common['Authorization'] = `Bearer ${auth.getToken()}`;
    api.defaults.headers.common['Content-Type'] = `application/x-www-form-urlencoded`;
  },

  query(resource, params) {
    return api.get(resource, params);
  },

  get(resource, slug = '') {
    return api.get(resource + (slug ? '/' + slug : ''));
  },

  // Fichier binaire (ex. CV PDF) : `get` traite son 2e argument comme un segment d'URL
  getBlob(resource) {
    return api.get(resource, { responseType: 'blob' });
  },

  post(resource, params) {
    return api.post(resource, params,);
  },

  patch(resource, params) {
    return api.patch(resource, params);
  },

  update(resource, slug, params) {
    return api.put(resource + '/' + slug, params);
  },

  put(resource, params) {
    return api.put(resource, params);
  },

  delete(resource, slug = '') {
    return api.delete(resource + (slug ? '/' + slug : ''));
  },

  // 🔒 Tour 69 (A3) : suppression avec un corps (fermeture du compte : mot de passe ou code reçu par e-mail)
  deleteWith(resource, slug, data) {
    return api.delete(resource + (slug ? '/' + slug : ''), { data });
  },
};

export default ApiService;
